document.querySelectorAll('.header__menu .reversed-link')
  .forEach(el => {
    if (el.textContent.trim().toLowerCase() === 'sale') {
      el.classList.add('menu-sale');
    }
  });

//   document.querySelector('.customer form').addEventListener('submit', function(){
//   var phone = document.getElementById('RegisterForm-phone').value;
//   document.getElementById('RegisterForm-phone').value = "Phone: " + phone;
// });
const customerForm = document.querySelector('.customer form');

if (customerForm) {
  customerForm.addEventListener('submit', function () {
    var phone = document.getElementById('RegisterForm-phone').value;
    document.getElementById('RegisterForm-phone').value = "Phone: " + phone;
  });
}
document.querySelectorAll('.facet-link').forEach(function(link){

  link.addEventListener('click', function(){

    const checkbox = this.querySelector('.fake-checkbox');

    if(checkbox){
      checkbox.classList.add('checked');
    }

  });

});
document.addEventListener("DOMContentLoaded", function () {

  const input = document.querySelector("#RegisterForm-phone");
  const hiddenInput = document.querySelector("#customer-note");

  const iti = window.intlTelInput(input, {
    initialCountry: "auto",
    separateDialCode: true,
    utilsScript: "{{ 'utils.js' | asset_url }}"
  });

  const form = input.closest("form");

  form.addEventListener("submit", function () {

    const dialCode = iti.getSelectedCountryData().dialCode;
    const number = input.value.trim();

    hiddenInput.value = "Country code: +" + dialCode + " " + number;

  });

});
// document.addEventListener("DOMContentLoaded", function(){

//   const input = document.querySelector("#phone");

//   const iti = window.intlTelInput(input, {
//     initialCountry: "ae",
//     preferredCountries: ["ae","sa","qa","kw","om","bh","in","pk","bd"],
//     separateDialCode: true,
//     utilsScript: "{{ 'utils.js' | asset_url }}"
//   });

//   const form = document.querySelector('.customer form');

//   form.addEventListener('submit', function(){

//     const fullNumber = iti.getNumber();

//     document.getElementById("customer-note").value =
//       "Phone: " + fullNumber;

//   });

// });


// document.addEventListener('DOMContentLoaded', function () {
//   const countrySelect = document.querySelector('[name="address[country]"]');

//   if (!countrySelect) return;

//   Array.from(countrySelect.options).forEach(option => {
//     if (option.value !== 'United Arab Emirates') {
//       option.style.display = 'none';
//     }
//   });

//   // force trigger change to load provinces
//   countrySelect.dispatchEvent(new Event('change'));
// });
document.addEventListener('DOMContentLoaded', function () {
  const countrySelect = document.querySelector('[name="address[country]"]');

  if (!countrySelect) return;

  Array.from(countrySelect.options).forEach(option => {
    if (option.value !== 'United Arab Emirates') {
      option.remove(); // ✅ works on iOS
    }
  });

  // ensure UAE selected
  countrySelect.value = 'United Arab Emirates';

  // trigger change for province load
  countrySelect.dispatchEvent(new Event('change'));
});